/*
 * @Author: zhangyin hbzyin@163.com
 * @Date: 2023-03-15 19:17:10
 * @LastEditors: hbzyin hbzyin@163.com
 * @LastEditTime: 2023-03-27 21:16:02
 * @FilePath: /mall-fe/src/comps/Announcent.tsx
 */
import { Modal } from 'antd';
import { MediaQueryContext } from 'libs/contexts';
import { useContext, useEffect, useState } from 'react';
import { Button, CountDown } from 'react-vant';
import {
  getAnnouncement,
  getAnnouncementDetail,
  announcementRead,
  getUserDetail,
  apiConfirmAnnouncement,
} from 'api/user';
import useUrl from 'hooks/useUrl';
import dayjs from 'dayjs';

export default function AnnouncementModal() {
  const { isMobile } = useContext(MediaQueryContext); // 是否为移动端
  const { getPublicUrl, buildDownloadUrl } = useUrl();
  const [visible, setVisible] = useState<boolean>(false); // 模态框是否显示
  const [queryNum, setQueryNum] = useState<number>(0); // 查询列表的第几个的详情
  const [modalData, setModalData] = useState<any>({}); // 公告详情数据
  const [list, setList] = useState<any[]>([]); // 公告列表
  const [userDetail, setuserDetail] = useState<any>({}); // 用户详情
  const [readingFlag, setReadingFlag] = useState<boolean>(false); // 是否强制阅读
  // 获取公告详情，在modal中显示
  const showAnnouncement = (sysNo: string) => {
    getAnnouncementDetail(sysNo).then((res) => {
      if (res.code === 200) {
        const { data } = res;
        stopBodyScroll(true);
        setQueryNum((queryNum) => ++queryNum);
        setVisible(true);
        setModalData(data);
        setReadingFlag(data?.mandatoryReadingFlag);
      }
    });
  };
  // 获取公告列表
  useEffect(() => {
    const { pathname } = window.location || {};
    if (['/delivery-order'].includes(pathname)) return;
    (async () => {
      const param = {
        pageSize: 999,
        alreadyReadFlag: false,
        isRemindQuery: true,
        pageNo: 1,
      };
      const res = await getAnnouncement(param);
      if (res.code === 200) {
        const { datas } = res.data;
        if (datas?.length) {
          const { sysNo } = datas[0];
          setList(datas);
          showAnnouncement(sysNo);
        }
      }
    })();
  }, []);
  // 获取用户详情
  useEffect(() => {
    (async () => {
      const { data } = await getUserDetail();
      setuserDetail(data?.profile);
    })();
  }, []);
  // 加载网络图片
  // useEffect(() => {
  //   const announcementMeta = document.createElement('meta');
  //   announcementMeta.name = 'referrer';
  //   announcementMeta.content = 'no-referrer';
  //   document.getElementsByTagName('head')[0].appendChild(announcementMeta);
  // }, []);

  // 再次显示模态框
  const isAgain = () => {
    if (queryNum < list?.length) {
      const sysNo = list[queryNum]?.sysNo;
      showAnnouncement(sysNo);
    } else {
      setList([]);
      setQueryNum(1);
      setModalData({});
    }
  };
  // 确认已读
  const onOk = () => {
    const readTime = dayjs().unix();
    const params = {
      announcementSysNo: modalData?.sysNo,
      tenantCode: modalData?.tenantCode,
      organizationSysNo: userDetail?.organizationSysNo,
      userSysNo: userDetail?.sysNo,
      organizationName: userDetail?.organizationName,
      displayName: userDetail?.displayName,
      mobile: userDetail?.mobile,
      readTime,
    };
    announcementRead(params).then((res) => {
      if (res?.code === 200) {
        stopBodyScroll(false);
        setVisible(false);
        isAgain();
      }
    });
  };
  // 阻止模态框滑动穿透
  const stopBodyScroll = (key: boolean) => {
    if (key) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100%';
    } else {
      document.body.style.overflow = 'scroll';
    }
  };
  const confirmBtnClick = async (processingStatus) => {
    try {
      await apiConfirmAnnouncement({
        announcementSysNo: modalData.sysNo,
        processingStatus,
      });
      stopBodyScroll(false);
      setVisible(false);
      isAgain();
    } catch (error) {}
  };

  return (
    <>
      <Modal
        className="iframe-modal"
        wrapClassName="announcement-modal"
        zIndex={1000}
        width={isMobile ? 300 : 800}
        title={modalData?.title || '公告'}
        visible={visible}
        keyboard={false}
        maskClosable={false}
        closable={false}
        destroyOnClose={true}
        centered
        footer={
          modalData?.isShowRefuse ? (
            <>
              <Button type="primary" onClick={() => confirmBtnClick(1)}>
                同意
              </Button>
              <Button style={{ marginLeft: '20px' }} onClick={() => confirmBtnClick(0)}>
                不同意
              </Button>
            </>
          ) : (
            <Button type={'primary'} onClick={onOk} disabled={readingFlag}>
              {readingFlag ? (
                <CountDown
                  time={modalData?.mandatoryReadingDuration * 1000}
                  format={`${modalData?.alreadyReadContent || '确定'}(sss)`}
                  onFinish={() => {
                    setReadingFlag(false);
                  }}
                />
              ) : (
                <span>{modalData?.alreadyReadContent || '确定'}</span>
              )}
            </Button>
          )
        }
      >
        <div
          className="content-wrap"
          onTouchMove={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: modalData?.content,
            }}
          />
          {modalData?.fileList?.length ? (
            <div className="announcement-file">
              <div>附件:</div>
              <div className="file-box">
                {modalData?.fileList?.map((item, index) => {
                  return (
                    <div key={index}>
                      <a
                        // href={`https://oss.3jyx.cn/public-3jyx-ga/platform${item?.url}`}
                        href={buildDownloadUrl(getPublicUrl(item.url), item.name)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item?.name}
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      </Modal>
      <style jsx>{`
        .content-wrap {
          height: 410px;
          overflow-y: auto;
          overflow-x: hidden;
          overscroll-behavior: contain;
        }
        .iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
        .announcement-modal {
          border-radius: 4px;
        }
        :global(.iframe-modal) :global(.ant-modal-body) {
          padding: 10px;
        }
        :global(.iframe-modal) :global(.ant-modal-footer) {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        :global(.iframe-modal) :global(.rv-count-down) {
          color: #ffffff;
        }
        .announcement-file {
          display: flex;
        }
        .file-box {
          margin-left: 10px;
        }
        .content-wrap :global(img) {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      `}</style>
    </>
  );
}
